import { useState, type FormEvent } from "react";
import { api, errorMessage, useStepUp } from "@/lib/api";
import { Button, Field, Input } from "./ui/core";
import { Dialog } from "./ui/overlay";

/** Shown when the server asks for a fresh password before a sensitive action
 * (LIVE trading, broker credentials, releasing the kill switch). */
export function StepUpDialog({ totp }: { totp: boolean }) {
  const { open, message, settle } = useStepUp();
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/api/auth/step-up", { password, totp: totp ? code : undefined });
      setPassword("");
      setCode("");
      settle(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) {
          setPassword("");
          setCode("");
          setError("");
          settle(false);
        }
      }}
      size="sm"
      title="Confirm it's you"
      description={message || "This action needs your password."}
    >
      <form onSubmit={submit} className="grid gap-3">
        <Field label="Password">
          <Input type="password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </Field>
        {totp && (
          <Field label="Authenticator code">
            <Input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" className="mono tracking-widest" maxLength={6} required />
          </Field>
        )}
        {error && <div className="text-[12.5px] text-down">{error}</div>}
        <div className="flex justify-end gap-2 pt-1">
          <Button type="button" variant="ghost" onClick={() => settle(false)}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" loading={busy}>
            Confirm
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
